mutation ApprovalTestResultCreate(
  $input: ApprovalTestResultCreateInput!
  $id: UUID!
) {
  approvalTestResultCreate(input: $input) {
    approvalTestResult {
      id
      _createdDate
      _fullComment
    }
    query {
      approval(id: $id) {
        _infoLines {
          isTested
          activeTestCount
        }
      }
    }
  }
}
